var map = {
	"./10.png": 196,
	"./11.png": 72,
	"./13.png": 197,
	"./16.png": 198,
	"./18.png": 73,
	"./8.png": 199,
	"./Loop.png": 76,
	"./Next.png": 74,
	"./Play.png": 200,
	"./Previous.png": 75,
	"./beep1.mp3": 71,
	"./beep1.wav": 201,
	"./certificate_01.jpg": 202,
	"./certificate_02.jpg": 78,
	"./click.png": 122,
	"./cursor_01.gif": 203,
	"./cursor_02.gif": 204,
	"./cursor_03.gif": 205,
	"./cursor_04.gif": 206,
	"./cursor_05.gif": 90,
	"./loader1.gif": 207,
	"./loader2.gif": 208,
	"./loader3.gif": 79,
	"./rotatedevice.png": 124,
	"./viarspaceMetalSignMockup_04.png": 51
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 195;